import React from 'react';
import { StanModal } from '@/components';
import { createIconElement } from '@/lib/utils/createIconElement';
import IcCopy from '@/assets/icons/ic-copy.svg';

interface DeleteAccountErrorModalProps {
    isOpen: boolean;
    failureReasons: string[];
    requestCode: string;
    onClose: () => void;
    onCopyRequestCode: () => void;
}

export const DeleteAccountErrorModal: React.FC<DeleteAccountErrorModalProps> = ({
    isOpen,
    failureReasons,
    requestCode,
    onClose,
    onCopyRequestCode,
}) => {
    return (
        <StanModal
            id='delete-stan-acct-failed-modal'
            isOpen={isOpen}
            title="Oops, we couldn't delete your account"
            onClose={onClose}
            primaryActionLabel='Close'
            onPrimaryAction={onClose}
        >
            <div className='space-y-4'>
                {failureReasons.length > 0 && (
                    <ul className='list-none space-y-2 px-0'>
                        {failureReasons.map((reason, index) => (
                            <li key={index} className='font-semibold'>
                                <p>• {reason}</p>
                            </li>
                        ))}
                    </ul>
                )}
                {requestCode && (
                    <div className='bg-neutral-subtle relative flex items-center justify-center rounded-lg p-4'>
                        <button
                            onClick={onCopyRequestCode}
                            className='absolute top-2 right-2 cursor-pointer opacity-70 transition-opacity hover:opacity-100'
                            aria-label='Copy request code'
                        >
                            {createIconElement(IcCopy)}
                        </button>
                        <div className='text-body-1-regular text-center font-normal'>{requestCode}</div>
                    </div>
                )}
                <div className='text-gray text-caption-1-regular text-center'>
                    <p>Need help?</p>
                    <p>
                        Copy the code above and send it to{' '}
                        <a href='mailto:friends@stanwith.me' className='underline'>
                            friends@stanwith.me
                        </a>
                        , and we&apos;ll give you a hand
                    </p>
                </div>
            </div>
        </StanModal>
    );
};
